import React, { useState, useEffect } from 'react';
import styled, { css } from 'styled-components';
import Logo from './Logo';
import DropdownList from './DropdownList';
import LoggedUser from '../../leftpanel/LoggedUser';
import { useDispatch, useSelector } from 'react-redux';
import { setFilters } from '../../../modules/cases';
import { useHistory } from 'react-router-dom';
import { initializeForm } from '../../../modules/case';
import { logout } from '../../../modules/user';
import { selectedMenu } from '../../../modules/leftpanel';
import FirstLoginModal from '../../common/FirstLoginModal';
import QRCodeScanner from './QRCodeScanner';
import client from '../../../lib/api/client';

const Rectangle = styled.div`
  display: flex;
  width: 100%;
  height: 55px;
  background-color: #ffffff;

  .top-right {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    flex-grow: 1;
    margin-right: 20px;
  }
`;

const Contour = styled.div`
  width: 100%;
  height: 1px;
  background-color: #e7e9ea;
`;

const MobileTop = ({ language, lngs, onSelect, isLogined }) => {
  const { leftpanel, user, user_checking, odm } = useSelector(
    ({ app, leftpanel, user, loading, cases }) => ({
      odm: app.odm,
      leftpanel,
      user: user.user,
      user_checking: loading['user/CHECK'],
    }),
  );
  const dispatch = useDispatch();
  let history = useHistory();
  const [showFirstLoginModal, setShowFirstLoginModal] = useState(false);
  const [showScanner, setShowScanner] = useState(false);
  const [firstLoginHandled, setFirstLoginHandled] = useState(false);

  useEffect(() => {
    try {
      const uStr = localStorage.getItem('user');
      if (uStr) {
        const u = JSON.parse(uStr);
        if (u.is_first_login === false) setFirstLoginHandled(true);
      }
    } catch (e) {}
  }, []);

  useEffect(() => {
    if (firstLoginHandled) return;
    if (
      !user_checking &&
      user &&
      user.is_first_login === true &&
      odm.name === 'HCLOUD'
    ) {
      setShowFirstLoginModal(true);
    }
  }, [user, user_checking, odm, firstLoginHandled]);

  const handleCloseFirstLoginModal = async () => {
    setShowFirstLoginModal(false);
    // try {
    //   await client.post('/v1/auth/set-first-login-viewed/');
    // } catch (error) {
    //   console.error('Failed to update first login status:', error);
    // }
  };

  const handleRegisterDeviceFromModal = () => {
    setShowFirstLoginModal(false);
    setShowScanner(true);
  };

  const handleDeviceRegistered = async () => {
    try {
      await client.post('/v1/auth/set-first-login-viewed/').catch(() => {});
      const userStr = localStorage.getItem('user');
      if (userStr) {
        const u = JSON.parse(userStr);
        u.is_first_login = false;
        localStorage.setItem('user', JSON.stringify(u));
      }
    } catch (e) {
    } finally {
      setFirstLoginHandled(true);
      setShowScanner(false);
      setShowFirstLoginModal(false);
    }
  };

  const logoutUser = () => {
    if (window.es) {
      window.es.close();
      delete window.es;
    }
    localStorage.removeItem('user');
    localStorage.removeItem('settings');
    localStorage.removeItem('caseFilters');

    dispatch(initializeForm('content'));
    dispatch(logout());
  };

  const onPersonalSelect = (id) => {
    if (id === 'Sign out') {
      history.push('/');

      dispatch(
        setFilters({
          status: [],
          unreadCommentsOnly: false,
          createDateFrom: null,
          createDateTo: null,
          institution: 'All',
          person: 'All',
          searchString: '',
          orderBy: '',
        }),
      );
      // dispatch(logout());
      logoutUser();
    } else {
      dispatch(selectedMenu(id));
    }
  };
  return (
    <>
      <Rectangle>
        <Logo margin="14px 0px 0px 20px" width="174px" height="24px" />
        {language && (
          <div className="top-right">
            <DropdownList
              width="108px"
              height="36px"
              // defaultValue={languageName}
              // items={{
              //   de: 'Deutsch',
              //   en: 'English',
              //   es: 'español',
              //   fr: 'français',
              //   ja: '日本語',
              // }}
              defaultValue={language}
              items={lngs}
              onSelect={onSelect}
            />
          </div>
        )}
        {isLogined && !user_checking && (
          <LoggedUser
            img={user.picture}
            name={(user.first_name + ' ' + user.last_name).trim()}
            width="254px"
            height="55px"
            collapsed={leftpanel.collapsed || leftpanel.collapsedAuto}
            onSelect={onPersonalSelect}
          />
        )}
      </Rectangle>
      <Contour></Contour>
      <FirstLoginModal
        show={showFirstLoginModal}
        onClose={handleCloseFirstLoginModal}
        onRegisterDevice={handleRegisterDeviceFromModal}
      />
      {showScanner && (
        <QRCodeScanner
          show={showScanner}
          onClose={() => setShowScanner(false)}
          user={user}
          onRegisterSuccess={handleDeviceRegistered}
        />
      )}
    </>
  );
};

export default React.memo(MobileTop);
